module.exports = __webpack_public_path__ + "static/613-5381b38ec075b6dde975f37b21ef77c5.png";